// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/chunks/" + chunkId + "." + {"789":"8667b47e","886":"c77823f7"}[chunkId] + ".js";
};